import _asyncToGenerator from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent, ref } from "vue";
import ModalLayout from "@/components/modals/ModalLayout.vue";
import UploadButton from "../parts/UploadButton.vue";
import axios from "axios";
import { setImgName, getImageUrl } from "@/core/helpers/config";
import { ElNotification } from "element-plus";
import UploadImageSVG from "../../../assets/svg/UploadImageSVG.vue";

var __default__ = defineComponent({
  props: {
    payload: Object
  },
  components: {
    ModalLayout: ModalLayout,
    UploadButton: UploadButton,
    UploadImageSVG: UploadImageSVG
  },

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  setup: function setup() {
    var color = process.env.VUE_APP_COLOR;
    var idEspace = ref(1);
    var loading = ref(false);
    var espacesExemple = ref([]);
    var spinnerSvg = "\n        <path class=\"path\" d=\"\n          M 30 15\n          L 28 17\n          M 25.61 25.61\n          A 15 15, 0, 0, 1, 15 30\n          A 15 15, 0, 1, 1, 27.99 7.5\n          L 15 15\n        \" style=\"stroke-width: 4px; fill: rgba(0, 0, 0, 0)\"/>\n      ";
    var image = ref("");
    var previewImage = ref([]);

    var handleUploadImage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var currentImage, lien, formData, imageName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                image.value = e.target.files[0];
                currentImage = e.target.files[0];
                lien = URL.createObjectURL(currentImage); // upload the image to the server

                loading.value = true;
                formData = new FormData();
                formData.set("file", image.value);
                _context.prev = 6;
                _context.next = 9;
                return axios.post(process.env.VUE_APP_API_URL + "upload-image", formData);

              case 9:
                imageName = _context.sent;
                setImgName(imageName.data); // add uploaded image to local storage

                previewImage.value.push({
                  link: lien,
                  name: imageName.data
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](6);
                ElNotification({
                  type: "error",
                  message: "Votre image n'est pas compatible"
                });

              case 17:
                _context.prev = 17;
                loading.value = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 14, 17, 20]]);
      }));

      return function handleUploadImage(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var chooseEspace = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, key) {
        var espace;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                espacesExemple.value = [];
                loading.value = true;
                _context2.prev = 2;
                _context2.next = 5;
                return axios.get(process.env.VUE_APP_API_URL + "process-image/getimages/" + key);

              case 5:
                espace = _context2.sent;
                espacesExemple.value = espace.data;
                idEspace.value = id;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                ElNotification({
                  type: "error",
                  message: "Erreur de connexion"
                });

              case 13:
                loading.value = false;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      }));

      return function chooseEspace(_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    var espaceData = ref([{
      espace: "Vos pièces",
      id: 1,
      key: "upload"
    }, {
      espace: "Cuisine",
      id: 2,
      key: "kitchen"
    }, {
      espace: "Salon",
      id: 3,
      key: "salon"
    }, {
      espace: "Salle à manger",
      id: 4,
      key: "diningRoom"
    }, {
      espace: "Chambre",
      id: 5,
      key: "bedroom"
    }, {
      espace: "Salle de bain",
      id: 6,
      key: "bathroom"
    }]);

    var chooseExample = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(imageName) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return setImgName(imageName);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function chooseExample(_x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      handleUploadImage: handleUploadImage,
      chooseEspace: chooseEspace,
      chooseExample: chooseExample,
      previewImage: previewImage,
      idEspace: idEspace,
      espaceData: espaceData,
      spinnerSvg: spinnerSvg,
      loading: loading,
      espacesExemple: espacesExemple,
      getImageUrl: getImageUrl,
      color: color
    };
  }
});

import { useCssVars as _useCssVars } from 'vue';

var __injectCSSVars__ = function __injectCSSVars__() {
  _useCssVars(function (_ctx) {
    return {
      "39426efb": _ctx.color
    };
  });
};

var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function (props, ctx) {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;